import { useEffect } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

const AcquisitionBanner = () => {
  const { t } = useLanguage();

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  return (
    <section className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/90 px-4 py-8 text-white">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(199,156,76,0.3),transparent_50%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom,rgba(23,34,52,0.8),transparent_55%)]" />

      <div className="relative w-full max-w-3xl rounded-3xl border border-[#c79c4c]/50 bg-gradient-to-br from-[#0f1729] via-[#111d33] to-[#0d1424] p-8 text-center shadow-[0_20px_80px_rgba(0,0,0,0.55)] sm:p-12">
        <p className="mb-4 inline-block rounded-full border border-[#c79c4c]/70 bg-[#c79c4c]/20 px-4 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-[#f1d59d]">
          {t('acquisition.label')}
        </p>

        <div className="mx-auto mb-8 flex h-40 w-72 items-center justify-center rounded-2xl bg-white px-4 py-3 shadow-[0_10px_30px_rgba(0,0,0,0.25)]">
          <img
            src="/artifex-logo.png"
            alt="Artifex Systems Slovakia logo"
            className="h-full w-full object-contain"
            loading="eager"
          />
        </div>

        <h2 className="mb-4 text-3xl font-bold leading-tight text-white sm:text-4xl">
          {t('acquisition.title')}
        </h2>

        <p className="mx-auto mb-8 max-w-2xl text-base text-slate-200 sm:text-lg">
          {t('acquisition.description')}
        </p>

        <a
          href="https://www.artifex-systems.sk/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 rounded-full bg-[#c79c4c] px-8 py-3 text-sm font-semibold text-[#101625] transition hover:bg-[#d6af66] sm:text-base"
        >
          {t('acquisition.cta')}
          <ArrowUpRight className="h-4 w-4" />
        </a>

        <p className="mt-5 text-sm text-slate-300">
          {t('acquisition.blockingNote')}
        </p>
      </div>
    </section>
  );
};

export default AcquisitionBanner;
